'use strict';

var _require = require('@sanity/block-content-to-hyperscript/internals'),
    getImageUrl = _require.getImageUrl,
    getSerializers = _require.getSerializers,
    blocksToNodes = _require.blocksToNodes,
    mergeSerializers = _require.mergeSerializers;

var mdSerializers = require('./serializers');

var renderNode = function renderNode(render, props, childNodes) {
  var children = childNodes || props.node && props.node.children;
  return render(Object.assign({}, props, { children: children }));
};

var _getSerializers = getSerializers(renderNode),
    defaultSerializers = _getSerializers.defaultSerializers,
    serializeSpan = _getSerializers.serializeSpan;

var markdownSerializers = mergeSerializers(defaultSerializers, mdSerializers);

var toMarkdown = function toMarkdown(block) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var blocks = block || [];
  var serializers = mergeSerializers(markdownSerializers, options.serializers || {});
  var props = Object.assign({}, options, { blocks: blocks, serializers: serializers, listNestMode: 'last-child' });
  return blocksToNodes(renderNode, props, defaultSerializers, serializeSpan).trim();
};

// Expose default serializers to the user
toMarkdown.defaultSerializers = defaultSerializers;

// Expose logic for building image URLs from an image reference/node
toMarkdown.getImageUrl = getImageUrl;

module.exports = toMarkdown;
//# sourceMappingURL=toMarkdown.js.map